import { http } from '@/core/services'
import { IRequirementsParams, IRequirementsResponse } from './interfaces'

export const getEntryRequirementsReq = (params: IRequirementsParams) => {
    return http.get<IRequirementsResponse>('entry-requirements', { params })
}
